import * as ActionTypes from 'constants';

export const tasks = (state = {
	assigned_to_me: [],
	assigned_by_me: [],
	initializing_tasks: false,
	updating_task: false
}, action) => {

	const { type, payload } = action;

	switch(type) {
		case ActionTypes.INIT_TASKS:
			return { ...state, tasks: payload };
		case ActionTypes.TOGGLE_INITIALIZING_TASKS:
			return { ...state, initializing_tasks: payload != null ? payload : !state.initializing_tasks };
		case ActionTypes.INIT_TASKS_ASSIGNED_TO_ME:
			return { ...state, assigned_to_me: payload };
		case ActionTypes.INIT_TASKS_ASSIGNED_BY_ME:
			return { ...state, assigned_by_me: payload };
		case ActionTypes.ADD_NEW_TASK_ASSIGNED_TO_ME:
			return { ...state, assigned_to_me: [ ...state.assigned_to_me, payload ] };
		case ActionTypes.ADD_NEW_TASK_ASSIGNED_BY_ME:
			return { ...state, assigned_by_me: [ ...state.assigned_by_me, payload ] };
		case ActionTypes.UPDATE_TASK:
		return {
			...state,
			assigned_to_me: state.assigned_to_me.map(t => t._id == payload._id ? payload : t),
			assigned_by_me: state.assigned_by_me.map(t => t._id == payload._id ? payload : t)
		};
		case ActionTypes.DELETE_TASK:
			return {
				...state,
				assigned_to_me: state.assigned_to_me.filter(t => t._id != payload.task_id),
				assigned_by_me: state.assigned_by_me.filter(t => t._id != payload.task_id)
			};
		case ActionTypes.EDIT_TASK_SUCCESS:
			return {
				...state,
				assigned_to_me: state.assigned_to_me.map(t => t._id == payload.task._id ? payload.task : t),
				assigned_by_me: state.assigned_by_me.map(t => t._id == payload.task._id ? payload.task : t)
			};
		case ActionTypes.TOGGLE_UPDATING_TASK:
			return { ...state, updating_task: payload	!= null ? payload : !state.updating_task };
		default:
			return state;
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/common/reducers/tasks.js